module.exports = __webpack_public_path__ + "img/kindred.1a3c2d75.png";